import { Field } from '../../../types';

export enum FOTBOLLPLAY_CATEGORIES {
  PRESS_CONFERENCE = 'pressConference',
  MATCH = 'match',
  TRAINING = 'training',
  PRACTICE_MATCHES = 'practiceMatches',
  PRESEASON = 'preseason',
  HIGHLIGHTS = 'highlights',
  STUDIO_PROGRAM = 'studioProgram',
  REPORTAGE = 'reportage',
  SERIES = 'series',
  INTERVIEW = 'interview',
  CLUB_MEETING = 'clubMeeting',
  ARCHIVE = 'archive',
  SUSTAINABILITY = 'sustainability',
  EDUCATION = 'education',
  ALL = 'all',
}

export enum MODULE_TYPES {
  PROMO = 'MODULE_PROMO',
  PROMO_IMAGES = 'MODULE_PROMO_IMAGES',
  PROMO_VIDEO = 'MODULE_PROMO_VIDEO',
  PROMO_POLL = 'MODULE_PROMO_POLL',
  PROMO_SUBSCRIPTION = 'MODULE_PROMO_SUBSCRIPTION',
  PROMO_FLARIE = 'MODULE_PROMO_FLARIE',
  APP_PROMO = 'MODULE_APP_PROMO',
  APP_INFO = 'MODULE_APP_INFO',
  WIFI_CARD = 'MODULE_WIFI_CARD',
  LINKS = 'MODULE_LINKS',
  UNIBET_PROMO_WEBVIEW = 'MODULE_UNIBET_PROMO_WEBVIEW',
  SVENSKASPEL_PROMO = 'MODULE_SVENSKASPEL_PROMO',
  STANDINGS_TABLE = 'MODULE_STANDINGS_TABLE',
  TEAM_PLAYERS_BANNER = 'MODULE_TEAM_PLAYERS_BANNER',
  TEAM_PLAYERS = 'MODULE_TEAM_PLAYERS',
  CLUB_STREAMS_ARCHIVE = 'MODULE_CLUB_STREAMS_ARCHIVE',
  CLUB_STREAMS = 'MODULE_CLUB_STREAMS',
  NOTIFICATION_CARD = 'MODULE_NOTIFICATION_CARD',
  SIDE_SCROLLING_NEWS = 'MODULE_SIDE_SCROLLING_NEWS',
  SIDE_SCROLLING_TEAMS = 'MODULE_SIDE_SCROLLING_TEAMS',
  MATCH_CARD = 'MODULE_MATCH_CARD',
  MATCH_LIST_CARD = 'MODULE_MATCH_LIST_CARD',
  LEADER_TABLE_CARD = 'MODULE_LEADER_TABLE_CARD',
  LATEST_HIGHLIGHTS_PLUS_VIDEOS = 'MODULE_LATEST_HIGHLIGHTS_PLUS_VIDEOS',
  FOTBOLLPLAY_VIDEOS = 'MODULE_FOTBOLLPLAY_VIDEOS',
  STORIES = 'MODULE_STORIES',
  EDITORIAL = 'MODULE_EDITORIAL',
  OFFICIAL_HIGHLIGHTS_REELS = 'MODULE_OFFICIAL_HIGHLIGHTS_REELS',
}

export enum SCENE {
  STARTSCENE = 'STARTSCENE',
  SPELTIPSSCENE = 'SPELTIPSSCENE',
  SQUADSCENE = 'SQUADSCENE',
}

export enum DEVICES {
  MOBILE = 'mobile',
  TABLET = 'tablet',
  BOTH = 'both',
}

export interface Condition {
  modules: Module[];
  predefinedrule: string;
  scene: string;
}

export interface Module {
  fields: Field[];
  id: string;
  type: string;
  name: string;
  isNonRemoveable?: boolean;
}

export interface Scene {
  modules: Array<Module>;
  type: string;
}

export type ScenePayload = Array<{
  condition: {
    modules: any[];
    scene: Scene['type'];
    predefinedrule: string;
  };
}>;

export type ModuleTypeKeys = keyof typeof MODULE_TYPES;
export type PreviewModuleTypes = { [key in ModuleTypeKeys]: string } & {
  ['NO_PREVIEW_AVAILABLE']: string;
};

export interface FotbollPlayChannel {
  id: number;
  title: string;
}

export interface FotbollPlayTeamConfig {
  abbrv: string;
  playName: string;
  channels: FotbollPlayChannel[];
}
